import React from 'react';
import { FaCheck } from "react-icons/fa";
import './Directmarketing.css';


function Directmarketing() {
  return (
    <div id="directmarketing" className='direct-marketing'>
      <div className='aboutcontent'>
            <div className="direct-marketing-image-section">
              <img src='Directmarketing/direct_marketing.png' className="directmarketing-image" />
            </div>
            <div className="directmarketing-text-center">
                  <h1>Direct Marketing Solutions</h1>
                  <div className="directmarketing-underline"></div>
                  <p>Direct all support for exclusive products and services..
                    Our direct marketing team helps you connect width
                    customers through personalized, on-ground promotions.
                  </p>
              <ul class="directmarketing-list">
                <li><FaCheck className="tick-icon" />Door-to-door Marketing</li>
                <li><FaCheck className="tick-icon" />Field Sales Activites</li>
                <li><FaCheck className="tick-icon" />Branding & Activation Events</li>
                <li><FaCheck className="tick-icon" />Flyers & Broucher Distribution</li>
              </ul>
            </div>
            </div>
    </div>
  )
}


export default Directmarketing

